<template>
    <v-dialog v-model="isActive" width="590px" :fullscreen="$vuetify.breakpoint.xsOnly" scrollable
        transition="dialog-bottom-transition" persistent>
        <v-card class="rounded-0 ">
            <v-card class="rounded-0" elevation="0" height="120">
                <v-app-bar flat color="white" height="50" class="pa-5 ma-5">
                    <v-toolbar-title class="pr-1 font-weight-regular primary--text text-h4"
                        :class="(items.length > 1) ? 'text-center ' : 'text-center primary--text'"
                        style="white-space: normal; word-break: break-word;">{{ titulo }}</v-toolbar-title>
                </v-app-bar>
            </v-card>
            <!--             <v-card-title class="font-weight-regular text-h4 text-center justify-center primary--text py-5"
                style="word-break: break-word; ">
                {{ titulo }}</v-card-title> -->
            <v-card-text class="text-body-1 black--text ma-0 " v-if="this.resPreAfiliacion.success">
                <v-row class="ma-2">
                    <v-col cols="12" md="12">
                        <div>Ya completaste tu solicitud de afiliación.Recibirás por mail la confirmación.</div>
                        <div class="mt-3">
                            <div class="d-flex align-start mt-2">
                                <span>Si lo deseas, podés acercarte en cualquier momento a tu Delegación Distrital para
                                    realizar la designación de beneficiario.</span>
                            </div>
                        </div>
                    </v-col>
                    <v-col cols="12" md="12">
                        <v-alert type="orange" class="rounded-0 mt-2" dense icon="mdi-information"
                            color="orange darken-3">
                            Si no recibís el mail, revisá tu casilla de correo no deseado o spam.
                        </v-alert>
                    </v-col>
                </v-row>
                <div class="d-flex flex-column justify-center align-center ma-1 pa-0">
                    <v-btn elevation="0" class="pa-5" width="200" color="primary" @click="goToUrl">
                        CONTACTOS
                    </v-btn>
                    <v-btn class="pa-5 mt-1" outlined width="200" color="secondary" @click="confirmAndClose(true)">
                        CERRAR
                    </v-btn>
                </div>
            </v-card-text>
            <v-card-text class="text-body-1 black--text ma-0 " v-else>
                <v-row class="ma-2">
                    <v-col cols="12" md="12">
                        <div>{{ text }}</div>
                        <div class="mt-3" v-if="items && items.length">
                            <div v-for="(item, index) in items" :key="index" class="d-flex align-start mt-2">
                                <v-icon color="red">mdi-circle-small</v-icon>
                                <span>{{ item }}</span>
                            </div>
                        </div>
                    </v-col>
                </v-row>
                <div class="d-flex flex-column justify-center align-center ma-1 pa-0">
                    <v-btn class="pa-5 mt-1" outlined width="200" color="secondary" @click="confirmAndClose(false)">
                        CERRAR
                    </v-btn>
                </div>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>

import { mapGetters, mapActions } from 'vuex'

export default {
    name: 'DialogoBienvenida',
    props: {
        titulo: {
            type: String,
            default: '¡Bienvenida/o a la Caja de Psicólogos!'
        },
        text: {
            type: String,
            default: 'Ya completaste tu solicitud de afiliación. Recibirás por mail la confirmación.'
        },
        items: {
            type: Array,
            default: () => ['Si lo deseas, podés acercarte en cualquier momento a tu Delegación Distrital para realizar la designación de beneficiario']
        }
    },
    data() {
        return {
            isActive: false,
            callback: null,
            text: '',
            items: []
        }
    },
    computed: {
        ...mapGetters('preafiliacion', ['matricula', 'resPreAfiliacion']),
    },
    methods: {
        confirmAndClose(result) {
            if (this.callback) {
                this.callback(result);
                this.callback = null;
            }
            this.isActive = false
        },
        goToUrl() {
            window.open('https://www.cajapsipba.org.ar/contacto.asp', '_blank');
        },

        abrirDialogo() {
            this.isActive = true;
            return new Promise(resolve => {
                this.callback = resolve;
            })
        },
    }
}

</script>